<template>
  <div id="quotes-create">
    <b-form @submit.prevent="submitQuote">
      <b-row>
        <b-col>
          <div class="form-group mb-2">
            <label class="control-label" v-translate>Quote Name</label>
            <input class="form-control" type="text" v-model="quotes.name" required :disabled="readOnly">
          </div>
          <div class="form-group mb-2">
            <label class="control-label" v-translate>Formula</label>
            <input ref="formula" class="form-control form-control-lg mb-3" type="text" v-model="quoteFormulas.formula" required :disabled="readOnly">
            <p v-if="!readOnly"><label class="control-label" v-translate>Variables</label>
              <b-button style="padding: 0.1rem 1rem;" @click.prevent="quoteFormulas.formula = quoteFormulas.formula + '{kms}'; $refs.formula.focus()">{kms}</b-button>
              <b-button style="padding: 0.1rem 1rem;" @click.prevent="quoteFormulas.formula = quoteFormulas.formula + '{visits}'; $refs.formula.focus()">{visits}</b-button>
              <b-button style="padding: 0.1rem 1rem;" @click.prevent="quoteFormulas.formula = quoteFormulas.formula + '{kmsRange}'; $refs.formula.focus()">{kmsRange}</b-button>
              <b-button style="padding: 0.1rem 1rem;" @click.prevent="quoteFormulas.formula = quoteFormulas.formula + '{kgms}'; $refs.formula.focus()">{kgms}</b-button>
            </p>
          </div>
          <div class="form-group mb-2">
            <label class="control-label" v-translate>Courier Commission Formula</label>
            <small tabindex="-1" class="form-text text-muted" v-translate>Must be simple and it doesn't support Custom Values (ie. <em>{shippingPrice}*0.5</em>)</small>
            <input ref="courierCommissionFormula" class="form-control form-control-lg mb-3" type="text" v-model="quoteFormulas.formulaCourierCommission" required :disabled="readOnly">
            <p v-if="!readOnly"><label class="control-label" v-translate>Variable</label>
              <b-button style="padding: 0.1rem 1rem;" @click.prevent="quoteFormulas.formulaCourierCommission = quoteFormulas.formulaCourierCommission + '{shippingPrice}'; $refs.courierCommissionFormula.focus()">{shippingPrice}</b-button>
            </p>
          </div>
          <div class="form-group mb-2">
            <label class="control-label" v-translate>Courier Commission Formula <strong>for Tours</strong></label>
            <small tabindex="-1" class="form-text text-muted" v-translate>Must be simple and it doesn't support Custom Values (ie. <em>{shippingPrice}*0.5</em>)</small>
            <input ref="courierCommissionFormulaTour" class="form-control form-control-lg mb-3" type="text" v-model="quoteFormulas.formulaCourierCommissionTour" :disabled="readOnly">
            <p v-if="!readOnly"><label class="control-label" v-translate>Variable</label>
              <b-button style="padding: 0.1rem 1rem;" @click.prevent="quoteFormulas.formulaCourierCommissionTour = quoteFormulas.formulaCourierCommissionTour + '{shippingPrice}'; $refs.courierCommissionFormulaTour.focus()">{shippingPrice}</b-button>
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row>
            <div class="form-group mb-2 col-6">
              <label class="control-label" v-translate>Area From</label>
              <b-form-select v-model="quotes.areaIdFrom" :options="areasSelect" class="mb-3" :disabled="!!quotes.id">
                <template slot="first">
                  <option :value="null"><translate>Select Area</translate></option>
                </template>
              </b-form-select>
            </div>
            <div class="form-group mb-2 col-6">
              <label class="control-label" v-translate>Area To</label>
              <b-form-select v-model="quotes.areaIdTo" :options="areasSelect" class="mb-3" :disabled="!!quotes.id">
                <template slot="first">
                  <option :value="null"><translate>Select Area</translate></option>
                </template>
              </b-form-select>
            </div>
          </b-row>
          <b-row v-if="regionsSelect?.length">
            <div class="form-group mb-2 col-6">
              <label class="control-label" v-translate>Region From</label>
              <b-form-select v-model="quotes.regionIdFrom" :options="regionsSelect" class="mb-3" :disabled="!!quotes.id">
                <template slot="first">
                  <option :value="null"><translate>Select Region</translate></option>
                </template>
              </b-form-select>
            </div>
            <div class="form-group mb-2 col-6">
              <label class="control-label" v-translate>Region To</label>
              <b-form-select v-model="quotes.regionIdTo" :options="regionsSelect" class="mb-3" :disabled="!!quotes.id">
                <template slot="first">
                  <option :value="null"><translate>Select Region</translate></option>
                </template>
              </b-form-select>
            </div>
          </b-row>
          <b-row>
          <div class="form-group mb-2 col-6">
            <label class="control-label" v-translate>Shipping Size</label>
            <b-form-select v-model="quotes.sizeId" :disabled="readOnly" :options="shippingSizesSelect">
              <template slot="first">
                <option :value="null"><translate>All Sizes</translate></option>
              </template>
            </b-form-select>
          </div>
          <div class="form-group mb-2 col-6">
            <label class="control-label" v-translate>Shipping Type</label>
            <b-form-select v-model="quotes.shippingTypeId" :disabled="readOnly" :options="shippingTypesSelect">
              <template slot="first">
                <option :value="null"><translate>All Types</translate></option>
              </template>
            </b-form-select>
          </div>
          </b-row>
          <b-row>
            <div class="form-group mb-2 col-6">
              <label class="control-label" v-translate>Quote Type</label>
              <b-form-select v-model="quotes.type" required :disabled="readOnly">
                <option :value="null"><translate>Select one</translate></option>
                <option v-for="(type, index) in types" :value="type" :key="index">
                  {{ type }}
                </option>
              </b-form-select>
            </div>
            <div class="form-group mb-2 col-6">
              <label class="control-label" v-translate>Platform</label>
              <b-form-select v-model="quotes.platformId" :disabled="readOnly" :options="platformsSelect">
                <template slot="first">
                  <option :value="null"><translate>All Platforms</translate></option>
                </template>
              </b-form-select>
            </div>

          </b-row>
          <b-row>
            <div class="form-group mb-2 col-6">
              <label class="control-label" v-translate>Companies</label>
              <company-autocomplete :disabled="readOnly" v-if="!company" ref="companyAc" @selected="onSearchCompanySelected" />
              <b-badge v-for="(item, index) in quoteCompanies" :key="index" style="margin-right: 3px">
                {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeCompanyFromQuote(index)" v-if="!readOnly">×</b-badge>
              </b-badge>
            </div>
            <div class="form-group mb-2 col-6">
              <label class="control-label">&nbsp;</label>
              <b-form-checkbox v-model="quotes.applySurcharge" :value="1" :disabled="readOnly"><translate>Apply surcharges</translate></b-form-checkbox>
            </div>
          </b-row>
        </b-col>
        <b-col>
          <div class="form-group mb-2">
            <h4 v-translate>Standard Values</h4>
            <div v-for="(item, key) in quoteFormulaValues" :key="key" v-if="key !== 'values' && key !== 'id' && key !== 'createdAt' && key !== 'updatedAt'" class="mb-2">
              <label class="control-label">{{ '{' + key + '}' }}</label> <input class="form-control" type="number" step="0.01" v-model="quoteFormulaValues[key]" :required="quoteFormulas.formula.indexOf('{' + key + '}') !== -1" :disabled="readOnly">
            </div>

            <h4 class="control-label" v-translate>Custom Values</h4>
            <p v-translate>Custom Values will be autodiscovered when you add them to the formula and will appear below for you to set their values</p>
            <div v-for="(key, index) in valuesArray" :key="index" class="mb-2">
              <div v-if="key.indexOf('Range') !== -1">
                <label class="control-label">{{ '{' + key + '}' }}</label>
                <b-form-row v-for="(rangeValue, n) in quoteFormulaValues.values[key]" :key="key + n" class="mb-0">
                  <b-col sm="1"></b-col>
                  <b-col sm="7">
                    <b-form-row v-for="(subitem, subkey) in $data[key + 'Template']" :key="subkey + 'Remotes'" class="mb-1">
                      <b-col sm="4"><label class="control-label">{{ subkey }}</label></b-col>
                      <b-col sm="8"><input class="form-control" type="number" step="0.01" v-model="quoteFormulaValues.values[key][n][subkey]" :required="quoteFormulas.formula.indexOf('{' + key + '}') !== -1" :disabled="readOnly" /></b-col>
                    </b-form-row>
                  </b-col>
                  <b-col sm="4"><b-button size="sm" variant="danger" @click="removeRange(key, n)" v-translate>Remove</b-button></b-col>
                  <b-col sm="1"></b-col>
                  <b-col><hr></b-col>
                </b-form-row>
                <form @submit.prevent="addRange(key)">
                  <b-form-row class="mb-3">
                    <b-col sm="1"></b-col>
                    <b-col sm="7">
                      <b-form-row v-for="(subitem, subkey) in $data[key + 'Template']" :key="subkey + 'Create'" class="mb-1">
                        <b-col sm="4"><label class="control-label">{{ subkey }}</label></b-col>
                        <b-col sm="8"><input class="form-control" type="number" step="0.01" v-model="newRangeObject[subkey]" /></b-col>
                      </b-form-row>
                    </b-col>
                    <b-col>
                      <b-button size="sm" type="submit" v-translate>Add</b-button>
                    </b-col>
                  </b-form-row>
                </form>
              </div>
              <div v-else>
                <label class="control-label">{{ '{' + key + '}' }}</label> <input class="form-control" type="number" step="0.01" v-model="quoteFormulaValues.values[key]" required :disabled="readOnly" />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="!readOnly">
        <div class="text-center form-group col-12 form-actions">
          <b-button type="submit" variant="primary" size="lg" v-translate>Save Quote</b-button>
          <b-button type="reset" variant="outline-primary" size="lg" @click.prevent="resetData" v-translate>Cancel</b-button>
        </div>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'

export default {
  name: 'QuotesCreate',
  components: {
    CompanyAutocomplete
  },
  props: {
    quoteData: {
      type: Object,
      default: null
    },
    baseAreaFrom: {
      type: Object,
      default: null
    },
    baseAreaTo: {
      type: Object,
      default: null
    },
    baseCompany: {
      type: Object,
      default: null
    },
    isModal: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quotes: {
        name: '',
        areaIdFrom: null,
        areaIdTo: null,
        regionIdFrom: null,
        regionIdTo: null,
        companyId: null,
        sizeId: null,
        vehicleTypeId: null,
        shippingTypeId: null,
        platformId: null,
        type: null,
        quoteFormulaId: null,
        applySurcharge: 1
      },
      quoteCompanies: [],
      quoteFormulas: {
        formula: '',
        formulaCourierCommission: '',
        formulaCourierCommissionTour: '',
        parameters: [],
        quoteFormulaValueId: null
      },
      parametersList: [
        'kms',
        'visits',
        'shippingPrice',
        'kgms'
      ],
      quoteFormulaValues: {
        basePrice: null,
        minPrice: null,
        maxPrice: null,
        includedWeight: null,
        values: {}
      },
      newRangeObject: {},
      kmsRangeTemplate: {
        min: null,
        max: null,
        amount: null
      },
      valuesArray: [],
      areaFrom: null,
      areaTo: null,
      company: null,
      types: [
        'customer',
        'company'
      ],
      searchAreaFromQuery: '',
      searchAreaToQuery: '',
      acAreaOptions: {
        debounce: 500,
        placeholder: this.$gettext('Area Name'),
        inputClass: 'form-control'
      },
      searchCompanyQuery: '',
      acCompanyOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name'),
        inputClass: 'form-control'
      },
      minCharacter: 2
    }
  },
  watch: {
    areaFrom(val) {
      if (val !== null) {
        this.quotes.areaIdFrom = val.id
      } else {
        this.quotes.areaIdFrom = null
      }
    },
    areaTo(val) {
      if (val !== null) {
        this.quotes.areaIdTo = val.id
      } else {
        this.quotes.areaIdTo = null
      }
    },
    quoteCompanies(val) {
      console.log(val.length)
      if (val.length > 0) {
        this.quotes.type = 'company'
      } else {
        this.quotes.type = this.quotes.type || null
      }
    },
    company(val) {
      if (val !== null) {
        this.quotes.type = 'company'
        this.quotes.companyId = val.id
      } else {
        this.quotes.type = null
        this.quotes.companyId = null
      }
    },
    'quotes.applySurcharge': {
      handler(val) {
        console.log(val)
        if (val === false) {
          this.quotes.applySurcharge = 0
        }
      },
      deep: true
    },
    'quoteFormulas.formula': {
      handler(val) {
        this.customValuesAutodiscover()
      },
      deep: true
    },
    'quoteFormulas.formulaCourierCommission': {
      handler(val) {
        this.customValuesAutodiscover()
      },
      deep: true
    },
    'quoteFormulas.formulaCourierCommissionTour': {
      handler(val) {
        this.customValuesAutodiscover()
      },
      deep: true
    }
  },
  created() {
    this.fetchRegions()
    this.fetchPlatforms()
    this.fetchShippingSizes()
    this.fetchShippingTypes()
    this.fetchAreas()
  },
  mounted() {
    this.areaFrom = this.baseAreaFrom
    this.areaTo = this.baseAreaTo
    this.company = this.baseCompany
    if (!this.quoteData) {
      this.quotes.name = this.baseAreaFrom ? 'Area ' + this.baseAreaFrom.id + ': ' + this.baseAreaFrom.name + ' + ' : ''
      this.quotes.name = this.baseCompany ? this.quotes.name + 'Company ' + this.baseCompany.id + ': ' + this.baseCompany.name + ' + ' : this.quotes.name
      if (this.baseCompany) {
        this.quoteCompanies = [{
          id: this.baseCompany.id,
          name: this.baseCompany.name
        }]
      }
    } else {
      setTimeout(function () {
        this.quotes = this.keysToCamel(this.quoteData.quotes)
        this.quoteCompanies = this.quotes.quoteCompanies.map(x => { return {id: x.company.id, name: x.company.name} })
        // Transform old company_id to the new array
        if (this.quotes.companyId && this.quoteCompanies.length === 0) {
          this.quoteCompanies = [{
            id: this.baseCompany.id,
            name: this.baseCompany.name
          }]
        }
        if (!this.baseAreaFrom && this.quoteData.quotes.area_id_from !== null) {
          this.$http.get(this.$appConfig.api.baseUrl + 'areas/' + this.quoteData.quotes.area_id_from)
            .then(response => {
              this.areaFrom = response.data
            })
        }
        if (!this.baseAreaTo && this.quoteData.quotes.area_id_to !== null) {
          this.$http.get(this.$appConfig.api.baseUrl + 'areas/' + this.quoteData.quotes.area_id_to)
            .then(response => {
              this.areaTo = response.data
            })
        }
        if (!this.baseCompany && this.quoteData.quotes.company_id !== null) {
          this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + this.quoteData.quotes.company_id)
            .then(response => {
              this.company = response.data
            })
        }
        if (this.quoteData.quoteFormulas) {
          this.quoteFormulas = this.keysToCamel(this.quoteData.quoteFormulas)
          this.quoteFormulas.formulaCourierCommission = this.quoteData.quoteFormulas.formula_courier_commission || ''
          this.quoteFormulas.formulaCourierCommissionTour = this.quoteData.quoteFormulas.formula_courier_commission_tour || ''
          this.quoteFormulaValues = {...this.quoteFormulaValues, ...this.keysToCamel(this.quoteData.quoteFormulaValues)}
          this.valuesArray = Object.keys(this.quoteFormulaValues.values) || {}
        } else {
          this.$http.get(this.$appConfig.api.baseUrl + 'quote-formulas/' + this.quoteData.quotes.quote_formula_id)
            .then(response => {
              this.quoteFormulas = this.keysToCamel(response.data)

              this.$http.get(this.$appConfig.api.baseUrl + 'quote-formula-values/' + this.quoteFormulas.quoteFormulaValueId)
                .then(response => {
                  this.quoteFormulaValues = this.keysToCamel(response.data)
                  this.valuesArray = Object.keys(this.quoteFormulaValues.values) || {}
                  this.done = true
                })
            })
        }
        this.customValuesAutodiscover()
      }.bind(this), 1000)
    }
  },
  methods: {
    addRange(key) {
      if (!this.quoteFormulaValues.values[key] || !Array.isArray(this.quoteFormulaValues.values[key])) {
        this.quoteFormulaValues.values[key] = []
      }
      this.quoteFormulaValues.values[key].push(this.newRangeObject)
      this.newRangeObject = {}
    },
    removeRange(key, index) {
      this.quoteFormulaValues.values[key].splice(index, 1)
    },
    customValuesAutodiscover() {
      const excludeValues = [
        'kms',
        'visits',
        'shippingPrice',
        'kgms',
        'basePrice',
        'minPrice',
        'maxPrice',
        'includedWeight'
      ]
      const parameters = [
        'kms',
        'visits',
        'shippingPrice',
        'kgms'
      ]
      const regexp = /\{([^}]+)\}/g
      let valuesArray = []
      let paramsArray = []
      let match = regexp.exec(this.quoteFormulas.formula + this.quoteFormulas.formulaCourierCommission + this.quoteFormulas.formulaCourierCommissionTour)
      while (match !== null) {
        if (excludeValues.indexOf(match[1]) === -1) {
          valuesArray.push(match[1])
        }
        if (parameters.indexOf(match[1]) !== -1) {
          paramsArray.push(match[1])
        }
        match = regexp.exec(this.quoteFormulas.formula + this.quoteFormulas.formulaCourierCommission + this.quoteFormulas.formulaCourierCommissionTour)
      }
      this.valuesArray = [...new Set(valuesArray)]
      this.quoteFormulas.parameters = JSON.stringify([...new Set(paramsArray)])
    },
    submitQuote() {
      if (!this.quoteData) {
        console.log(this.keysToSnake(this.quoteFormulaValues))
        let paramsQuoteFormulaValues = this.keysToSnake(this.quoteFormulaValues)

        this.$http.post(this.$appConfig.api.baseUrl + 'quote-formula-values', paramsQuoteFormulaValues)
          .then(response => {
            console.log(response)
            this.quoteFormulas.quoteFormulaValueId = response.body.id

            let paramsQuoteFormulas = this.keysToSnake(this.quoteFormulas)
            this.$http.post(this.$appConfig.api.baseUrl + 'quote-formulas', paramsQuoteFormulas)
              .then(response => {
                console.log(response)
                this.quotes.quoteFormulaId = response.body.id

                let paramsQuotes = this.keysToSnake(this.quotes)

                if (paramsQuotes.area_id_from && paramsQuotes.area_id_to) {
                  delete paramsQuotes.region_id_from
                  delete paramsQuotes.region_id_to
                } else if (paramsQuotes.region_id_from && paramsQuotes.region_id_to) {
                  delete paramsQuotes.area_id_from
                  delete paramsQuotes.area_id_to
                }
                this.$http.post(this.$appConfig.api.baseUrl + 'quotes', paramsQuotes)
                  .then(response => {
                    console.log(response)
                    if (this.quoteCompanies.length > 0) {
                      let companyIds = this.quoteCompanies.map(x => { return x.id })
                      this.$http.post(this.$appConfig.api.baseUrl + 'quotes/' + response.body.id + '/companies', companyIds)
                        .then(response => {
                          if (!this.isModal) {
                            this.$router.push({ name: 'modelList', params: { type: 'quotes' }, query: { created: true } })
                          } else {
                            this.$emit('quotecreated', response.body)
                          }
                        })
                    } else {
                      if (!this.isModal) {
                        this.$router.push({ name: 'modelList', params: { type: 'quotes' }, query: { created: true } })
                      } else {
                        this.$emit('quotecreated', response.body)
                      }
                    }
                  })
              })
          })
      } else {
        console.log(this.keysToSnake(this.quoteFormulaValues))
        let paramsQuoteFormulaValues = this.keysToSnake(this.quoteFormulaValues)

        this.$http.patch(this.$appConfig.api.baseUrl + 'quote-formula-values/' + this.quoteFormulaValues.id, paramsQuoteFormulaValues)
          .then(response => {
            console.log(response)

            let paramsQuoteFormulas = this.keysToSnake(this.quoteFormulas)
            this.$http.patch(this.$appConfig.api.baseUrl + 'quote-formulas/' + this.quoteFormulas.id, paramsQuoteFormulas)
              .then(response => {
                console.log(response)

                let paramsQuotes = this.keysToSnake(this.quotes)
                this.$http.patch(this.$appConfig.api.baseUrl + 'quotes/' + this.quotes.id, paramsQuotes)
                  .then(response => {
                    console.log(response)
                    // Always
                    let companyIds = this.quoteCompanies.map(x => { return x.id })
                    this.$http.post(this.$appConfig.api.baseUrl + 'quotes/' + this.quotes.id + '/companies', companyIds)
                      .then(response => {
                        this.$emit('quoteupdated', response.body)
                      })
                  })
              })
          })
      }
    },
    onSearchCompanySelected(item) {
      this.company = item
      this.quoteCompanies.push({id: item.id, name: item.name})
      this.$refs.companyAc.searchQuery = ''
    },
    removeCompanyFromQuote(index) {
      this.quoteCompanies.splice(index, 1)
    },
    camelToSnake(key) {
      return key.replace(/([A-Z])/g, '_$1').toLowerCase()
    },
    snakeToCamel(key) {
      return key.replace(/([-_][a-z])/ig, ($1) => {
        return $1.toUpperCase()
          .replace('-', '')
          .replace('_', '')
      })
    },
    keysToSnake(o, recursive) {
      if (o === Object(o) && !Array.isArray(o) && typeof o !== 'function') {
        const n = {}

        Object.keys(o)
          .forEach((k) => {
            if (recursive) {
              n[this.camelToSnake(k)] = this.keysToSnake(o[k])
            } else {
              n[this.camelToSnake(k)] = o[k]
            }
          })

        return n
      } else if (Array.isArray(o)) {
        return o.map((i) => {
          return this.keysToSnake(i)
        })
      }

      return o
    },
    keysToCamel(o, recursive) {
      if (o === Object(o) && !Array.isArray(o) && typeof o !== 'function') {
        const n = {}

        Object.keys(o)
          .forEach((k) => {
            if (recursive) {
              n[this.snakeToCamel(k)] = this.keysToCamel(o[k])
            } else {
              n[this.snakeToCamel(k)] = o[k]
            }
          })

        return n
      } else if (Array.isArray(o)) {
        return o.map((i) => {
          return this.keysToCamel(i)
        })
      }

      return o
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$emit('cancel')
    }
  }
}
</script>
